import { RadioOption } from "../../component-library";

export const YesNoRadioOptions: RadioOption[] = [
    { label: "Yes", value: "yes" },
    { label: "No", value: "no" },
];

export const YesNoNARadioOptions: RadioOption[] = [
    { label: "Yes", value: "yes" },
    { label: "No", value: "no" },
    { label: "N/A", value: "N/A" },
];

export const EventsLeadingToDeathOptions = [
    {
        text: "Patient was a witness arrest and was transported to the ER via EMS with full ACLS protocol, resuscitation efforts failed and patient was pronounced.",
        inputs: [],
    },
    {
        text: "Patient was found down and was transported to the ER via EMS with full ACLS protocol, resuscitation efforts failed and patient was pronounced.",
        inputs: [],
    },
    {
        text: "Patient was found down and was pronounced at the scene with {input1} medical intervention.",
        inputs: [{ accessor: "eventsLeadingToDonorsDeath.events.medicalIntervention", placeholder: "{input1}" }],
    },
    {
        text: "Patient was admitted for: {input1}, and underwent a {input2}. Patient's health continued to deteriorate and coded on the unit, full ACLS protocol, resuscitation efforts failed and patient was pronounced.",
        inputs: [
            { accessor: "eventsLeadingToDonorsDeath.events.admittedFor1", placeholder: "{input1}" },
            { accessor: "eventsLeadingToDonorsDeath.events.underwentA", placeholder: "{input2}" },
        ],
    },
    {
        text: "Patient was admitted for: {input1}, patient's health continued to deteriorate and was made a DNR and expired shortly afterwards.",
        inputs: [{ accessor: "eventsLeadingToDonorsDeath.events.admittedFor2", placeholder: "{input1}" }],
    },
    {
        text: "Patient was on home hospice for end of life care due to: {input1}. Patient's health continued to deteriorate and expired at home.",
        inputs: [{ accessor: "eventsLeadingToDonorsDeath.events.hospiceDueTo", placeholder: "{input1}" }],
    },
    {
        text: "Patient was admitted for: {input1}, patient's health continued to deteriorate and progressed to brain death. Patient later became an organ, tissue and ocular donor.",
        inputs: [{ accessor: "eventsLeadingToDonorsDeath.events.admittedFor3", placeholder: "{input1}" }],
    },
    {
        text: "Other: {input1}",
        inputs: [{ accessor: "eventsLeadingToDonorsDeath.events.other", placeholder: "{input1}", type: "textarea" }],
    },
    // {
    //     text: "The donor on a ventilator, amount of time: {input1}",
    //     inputs: [{ accessor: "eventsLeadingToDonorsDeath.events.ventilatorTime", placeholder: "{input1}" }],
    // },
];
